import React from 'react';
import { Row, Col, Card, CardBody, CardText, Button } from 'reactstrap';
import './laudos-anteriores.styles.css';
import { urlImagemRadiologia } from '../../../../pages/laudo/etapas/etapas.common.util';
import IntlMessage from "../../../../helpers/intlMessage";
const LaudosAnterioresPage = props => {
  return (
    <Col
      className='laudos-anteriores-container espacamento-container-lateral'
      style={{
        height: props.alturaEditor(),
        overflowY: 'auto',
        overflowX: 'hidden'
      }}
    >
      {props.laudos === undefined && (
        <p className='mv-semItem'><IntlMessage id="dashboards.examDetail.noPreviousReportRegistered" /></p>
      )}
      {props.laudos !== undefined &&
        props.plainTextLaudo === undefined &&
        props.laudos.map(laudo => {
          return (
            <Row key={laudo.id}>
              <Col>
                <Card
                  className={`${laudo.laudo === props.active ? 'active' : ''} ${laudo.critico ? 'critico' : ''
                    }`}
                >
                  <CardBody
                  >
                    <CardText  onClick={() => {
                      props.getLaudoFinal(laudo);
                    }}>
                      <IntlMessage id="dashboards.general.report" />:
                      {`${laudo.laudo}`}
                    </CardText>

                    <CardText  onClick={() => {
                      props.getLaudoFinal(laudo);
                    }}>
                      <IntlMessage id="dashboards.examDetail.numberOfExam" />
                      {`${laudo.numeroExame}`}
                    </CardText>

                    {/* <CardText>
                      <IntlMessage id = "dashboards.examDetail.date"/>
                      {`${props.laudo && laudo.data ? laudo.data : ''}`}
                    </CardText> */}
                      <CardText  onClick={() => {
                      props.getLaudoFinal(laudo);
                    }}>
                        <IntlMessage id="dashboards.examDetails.exam" />
                        {`${laudo.exame}`}
                      </CardText>

                    {laudo.critico && (
                      <CardText  onClick={() => {
                        props.getLaudoFinal(laudo);
                      }}>
                        <i className='fas fa-plus-circle'></i>
                        <IntlMessage id="dashboards.examDetails.criticalReport" />
                      </CardText>
                    )}

                    {laudo.possuiImagemRadiologica && (
                        <CardText onClick={() =>
                          urlImagemRadiologia(props.commonActions, laudo.acNumber, laudo.prontuario)}>
                          <div  className='button' style={{cursor: 'pointer', top: '16px', position: 'absolute', right: '15px' }} ><i className='fas fa-eye'></i>
                            <u><i>Vivace Connect</i></u></div>
                        </CardText>)}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          );
        })}
      {props.plainTextLaudo !== undefined && (
        <div
          className='laudoAnteriorContainer'
          style={{
            // height: `${props.altura - 47}px`,
            height: `100%`,
            overflowY: 'auto',
            overflowX: 'hidden'
          }}
        >
          <div className='detalhes'>
            <p><IntlMessage id="dashboards.general.report" />: {props.laudo.laudo}</p>
            <p><IntlMessage id="dashboards.examDetail.numberOfExam" />  {props.laudo.numeroExame}</p>
            {/* <p><IntlMessage id = "dashboards.examDetail.date"/> {props.laudo.data}</p> */}
            <p><IntlMessage id="dashboards.examDetails.exam" /> {props.laudo.exame}</p>
            {props.laudo.critico && (
              <p>
                <i className='fas fa-plus-circle'></i> <IntlMessage id="dashboards.examDetails.criticalReport" />
              </p>
            )}
          </div>
          <textarea value={props.plainTextLaudo} disabled={true}></textarea>
          <Button
            color='link'
            onClick={props.voltarLaudoDoExame}
            className='voltar'
          >
            <i className='fa-3x fas fa-times'></i>
          </Button>
        </div>
      )}
    </Col>
  );
};

export default LaudosAnterioresPage;



// WEBPACK FOOTER //
// ./src/app/common/tabs/anteriores/laudos-anteriores.page.js